import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";
import { AutoSellSetting } from "./types";
import { BotAutoSellSettingResponse } from "@api/bot/bot-get-auto-sell-setting.ts";

const BOT_UPDATE_AUTO_SELL_SETTING_QUERY_KEY = "bot-update-auto-sell-setting";

type BotUpdateAutoSellSettingParams = {
  appPubKey: string;
  userId: string;
  autoSellData: AutoSellSetting[];
};

const postBotUpdateAutoSellSetting = async (
  api: Api,
  params: BotUpdateAutoSellSettingParams,
): Promise<BotAutoSellSettingResponse> =>
  api.post("updateAutoSellSetting", { json: params }).json();

const useBotUpdateAutoSellSettingMutation = () =>
  useMutation<
    BotAutoSellSettingResponse,
    Error,
    BotUpdateAutoSellSettingParams
  >({
    mutationFn: async (params: BotUpdateAutoSellSettingParams) =>
      postBotUpdateAutoSellSetting(api, params),
    mutationKey: [BOT_UPDATE_AUTO_SELL_SETTING_QUERY_KEY],
  });

export {
  useBotUpdateAutoSellSettingMutation,
  postBotUpdateAutoSellSetting,
  BOT_UPDATE_AUTO_SELL_SETTING_QUERY_KEY,
};
